import { render, staticRenderFns } from "./AccountsDetail.vue?vue&type=template&id=734aaf67&scoped=true"
import script from "./AccountsDetail.vue?vue&type=script&lang=js"
export * from "./AccountsDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountsDetail.vue?vue&type=style&index=0&id=734aaf67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734aaf67",
  null
  
)

export default component.exports